module.exports = __webpack_public_path__ + "img/launcher-icon-2x.82d2b1fb.png";